import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-643d06d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-item relative mb-2 pt-5 pb-4 px-4 border border-line border-b-2 rounded-md bg-white md:pt-6 md:pb-8 md:px-8" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "font-semibold md:text-xl" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rs-trash text-2xl" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_7 = { class: "justify-between md:flex" }
const _hoisted_8 = { class: "md:flex" }
const _hoisted_9 = { class: "flex md:w-96" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-tr-cubes text-7xl text-placeholder" }, null, -1))
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = { class: "text-desc text-xs md:text-md" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "크기:", -1))
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = { class: "mt-2 text-desc text-xs md:text-md md:mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "부피:", -1))
const _hoisted_17 = { class: "ml-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_19 = { class: "mt-3 md:mt-4" }
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cubes" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 mr-1 text-sm md:text-md" }, "자동분석 결과: ", -1))
const _hoisted_24 = { class: "text-sm md:text-md" }
const _hoisted_25 = {
  key: 0,
  class: "m-auto mt-2 cs-caption"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-exclamation mr-1" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"1.3"} }, [
    /*#__PURE__*/_createTextVNode("위 항목을 클릭하면 상세 내용을"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("확인할 수 있습니다.")
  ])
], -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1))
const _hoisted_30 = { class: "mt-5 md:w-60 md:mt-0" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-desc" }, "공정·재료", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-3 border-b border-line" }, null, -1))
const _hoisted_33 = { class: "flex items-center mt-7 md:mt-5" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "info-paint form-check-label mr-5 text-xs md:text-md",
  for: "pating"
}, "도색", -1))
const _hoisted_35 = ["v-model"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-5 border-t border-line md:hidden" }, null, -1))
const _hoisted_38 = { class: "mt-5 md:w-24 md:mt-0" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-desc" }, "수량", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-3 border-b border-line" }, null, -1))
const _hoisted_41 = {
  class: "cs-form flex w-full",
  "data-height": "s"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-6 mr-6 border-l border-line" }, null, -1))
const _hoisted_43 = { class: "items-center justify-end mt-8 md:flex md:mt-0" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-desc" }, "단가", -1))
const _hoisted_47 = { class: "text-desc font-semibold" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-b border-line" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-3 text-1desc" }, "비용", -1))
const _hoisted_50 = { class: "text-4xl font-bold" }
const _hoisted_51 = {
  key: 0,
  class: "items-center justify-center bounding-loader rounded-md"
}
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\" data-v-643d06d0><div class=\"scene\" data-v-643d06d0><div class=\"plane\" data-v-643d06d0><div class=\"cube cube--0\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--0\" data-v-643d06d0></div><div class=\"cube cube--1\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--1\" data-v-643d06d0></div><div class=\"cube cube--2\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--2\" data-v-643d06d0></div><div class=\"cube cube--3\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--3\" data-v-643d06d0></div><div class=\"cube cube--4\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--4\" data-v-643d06d0></div><div class=\"cube cube--5\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--5\" data-v-643d06d0></div><div class=\"cube cube--6\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--6\" data-v-643d06d0></div><div class=\"cube cube--7\" data-v-643d06d0><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div><div class=\"cube__side\" data-v-643d06d0></div></div><div class=\"shadow shadow--7\" data-v-643d06d0></div></div></div></div><div class=\"bounding-loader-text text-center\" data-v-643d06d0><p class=\"\" data-v-643d06d0>업로드 및 분석 중 입니다, 잠시만 기다려주세요.</p></div>", 2)
const _hoisted_54 = [
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thumbnail = _resolveComponent("thumbnail")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.model.name), 1),
      (_ctx.isEstimateSubmit)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onTrash && _ctx.onTrash(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (_ctx.model)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_thumbnail, {
                  size: '',
                  url: _ctx.model.thumbnailUrl,
                  defaultIcon: false,
                  customCss: 'mr-6 w-24 h-24 bg-layout md:w-32 md:h-32',
                  borderWidth: 1,
                  borderColor: '#c0c2c4',
                  round: '5px'
                }, {
                  "default-icon": _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["url"]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(parseFloat(_ctx.model.modelSizeX.toFixed(2))) + " x " + _toDisplayString(parseFloat(_ctx.model.modelSizeY.toFixed(2))) + " x " + _toDisplayString(parseFloat(_ctx.model.modelSizeZ.toFixed(2))) + _toDisplayString(_ctx.model.modelUnit), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, [
                        _createTextVNode(_toDisplayString(_ctx.numberToComma(_ctx.model.modelVolume)) + "㎜", 1),
                        _hoisted_18
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["cs-btn cs-pd-btn-xs", [_ctx.classAnalysis]]),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onShowViewer && _ctx.onShowViewer(...args))),
                      id: 'btn_' + _ctx.model.id + '_analysis'
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _hoisted_23,
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.totalAnalysis), 1)
                      ])
                    ], 10, _hoisted_20),
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _hoisted_32,
                _createVNode(_component_dropdown, {
                  title: _ctx.dropProcessTitle,
                  items: _ctx.dropProcess,
                  onOnClick: _ctx.onDropProcess
                }, null, 8, ["title", "items", "onOnClick"]),
                _createVNode(_component_dropdown, {
                  class: "mt-3",
                  title: _ctx.dropMaterialTitle,
                  items: _ctx.dropMaterial,
                  onOnClick: _ctx.onDropMaterial
                }, null, 8, ["title", "items", "onOnClick"]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("input", {
                    class: "form-check-input",
                    id: "pating",
                    type: "checkbox",
                    "v-model": _ctx.model.modelPaint,
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChangePainting && _ctx.onChangePainting(...args)))
                  }, null, 40, _hoisted_35)
                ])
              ]),
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    class: "text-xs md:text-md",
                    type: "number",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelCount) = $event)),
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onModelCount && _ctx.onModelCount(...args))),
                    onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlurModelCount && _ctx.onBlurModelCount(...args))),
                    min: "1",
                    oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');"
                  }, null, 544), [
                    [_vModelText, _ctx.modelCount]
                  ])
                ])
              ]),
              _hoisted_42
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", null, [
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.numberToComma(_ctx.model.modelCost)), 1),
                    _createTextVNode(" 원 ")
                  ])
                ]),
                _hoisted_48,
                _createElementVNode("div", null, [
                  _hoisted_49,
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.numberToComma(_ctx.model.modelCost * _ctx.modelCount)) + "원", 1)
                ])
              ])
            ])
          ]),
          (_ctx.model.analysis && !_ctx.model.analysis.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}